import {
  AccordionItem,
  Text,
  List,
  Stack,
  Heading,
  Strong,
} from 'braid-design-system';
export const SectionD = () => (
  <AccordionItem id="section-d" label="Section D: Ad Selection with GraphQL">
    <Stack space="gutter">
      <Heading level="4">Functional</Heading>
      <List type="number" start={79}>
        <Text>
          Section D applies if you have chosen to use the Ad Selection with
          GraphQL functionality through the SEEK API.
        </Text>
        <Text>
          <Strong>Ad Selection with GraphQL</Strong> means the method used to
          programmatically retrieve available ad products by your backend during
          advertisement creation and modification.
        </Text>
        <Stack space="medium">
          <Text>You acknowledge and agree that:</Text>
          <List type="alpha">
            <Text>
              if you choose to utilise the Ad Selection with GraphQL
              functionality, it must be available to all Advertisers. Removal of
              Ad Selection with GraphQL for any Advertiser must be discussed and
              agreed with us beforehand;
            </Text>
            <Text>
              all SEEK Group products available through the Ad Selection with
              GraphQL must be and accessible to all Advertisers; and
            </Text>
            <Stack space="medium">
              <Text>
                pricing information surfaced via Ad Selection with GraphQL is
                not to be used for any other purpose other than for displaying:
              </Text>
              <List type="roman">
                <Text>
                  the price of our products to Advertisers who are posting job
                  ads in the flow;
                </Text>
                <Text>job posting spend analysis, and</Text>
                <Text>
                  other relevant reporting and management information.
                </Text>
              </List>
            </Stack>
          </List>
        </Stack>
      </List>
      <Heading level="4">Messaging / Branding</Heading>
      <List type="number" start={82}>
        <Text>
          Upon successfully integrating Ad Selection with GraphQL into the
          partner system, we will review the implementation to ensure the design
          appropriately represents our brand and value proposition. We may
          decide to end your integration with the SEEK API if we determine, in
          our sole discretion, that the design implemented by you does not
          appropriately represent our brand and value proposition.
        </Text>
      </List>
    </Stack>
  </AccordionItem>
);
